var _defs, _path, _path2, _line, _path3, _path4, _circle, _circle2, _circle3, _circle4, _rect, _line2, _rect2, _line3, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-192,.cls-190,.cls-189,.cls-187{fill:#fff;}.cls-192,.cls-191,.cls-190,.cls-189,.cls-188,.cls-187{stroke:#000;stroke-miterlimit:10;}.cls-192,.cls-191{stroke-width:0.84px;}.cls-191,.cls-188{fill:none;}.cls-190{stroke-width:3px;}.cls-187{stroke-width:1.85px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M267.06,85.12a367,367,0,0,1-18.37,71.76c-13.41,36.52-24.5,48.46-32.81,54.22-8.31-5.75-19.4-17.69-32.82-54.22a368.33,368.33,0,0,1-18.08-70c13.42,4.53,30.3,7.23,48.61,7.23C234.2,94.12,253,90.71,267.06,85.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M268.74,96a367.75,367.75,0,0,1-18.35,71.75c-13.4,36.52-24.5,48.46-32.81,54.22-8.31-5.75-19.4-17.68-32.81-54.22a368.33,368.33,0,0,1-18.08-70c13.42,4.52,30.29,7.23,48.6,7.23C235.87,105,254.69,101.59,268.74,96Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-191",
    x1: 215.3,
    y1: 105.01,
    x2: 216.35,
    y2: 216.93
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M227.08,428.22l-18.23-1.16-99.27-6.32c9.17-34.31,11.82-81.77,9.67-141.58-.77-21.23-1.88-40.3-4.36-57.52q-1.29-9-3.15-17.37-.78-3.45-1.66-6.79l1.39-.12h.22a44,44,0,0,0,5.25-.76,17.56,17.56,0,0,0,7.45-3.67l.3-.27c5.72-5.61,7.24-40.87.4-69.67-.46-2-1-3.88-1.51-5.77s-1.1-3.66-1.71-5.42v-1.67l.27-.14h.06l2-1.08,27.08-14.36,17.78-9.43c.47,1.09,1,2.17,1.52,3.22a197,197,0,0,0,8.81,38.06,199.84,199.84,0,0,0,39.48,67.88c1.8,2.05,3.57,4,5.3,5.8l.51,40.93Q225.94,334.61,227.08,428.22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M326.31,420.07l-117.5,7.48v-3.49q1.14-92.91,2.3-185.8l.48-38.85c2.38-2.5,4.84-5.21,7.33-8.13a199.64,199.64,0,0,0,37.45-65.55,197,197,0,0,0,8.81-38.06c.54-1,1.05-2.13,1.52-3.22l13.48,7.15,31.38,16.64,2,1.08h.13l.27.14v1.67q-.91,2.64-1.71,5.42c-.95,3.31-1.78,6.75-2.49,10.25-4.62,22.58-4.41,47.9-1.27,59.51.8,3,1.8,5.05,2.95,5.95a17.62,17.62,0,0,0,7.45,3.67,44.26,44.26,0,0,0,5.25.76h.26l1.39.12q-.89,3.34-1.66,6.79Q322.27,212,321,221c-2.48,17.22-3.59,36.29-4.36,57.52C314.49,338.34,317.14,385.76,326.31,420.07Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 222.54,
    cy: 289.27,
    r: 5.66
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 221.43,
    cy: 338.2,
    r: 5.66
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 221.43,
    cy: 247.01,
    r: 5.66
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 221.43,
    cy: 206.79,
    r: 5.66
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 255.65,
    y: 319.3,
    width: 56.76,
    height: 4.41
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-188",
    x1: 274.97,
    y1: 238.58,
    x2: 273.08,
    y2: 319.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 124.37,
    y: 320.12,
    width: 56.76,
    height: 4.41
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-188",
    x1: 161.8,
    y1: 239.4,
    x2: 163.7,
    y2: 320.12
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "295.63 198.81 255.65 198.81 260.26 189.58 298.89 189.58 295.63 198.81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyle3);
export default __webpack_public_path__ + "static/media/STYLE 3.b3ea7efa18b533eedd2ad5516ff5e87c.svg";
export { ForwardRef as ReactComponent };